import CounterpartyModel from "./CounterpartyModel";
import EmployeeModel from "./EmployeeModel";
import LegalEntityBranchModel from "./LegalEntityBranchModel";
import OrderItemModel from "./OrderItemModel";
import OrderItemSelectionDemandModel from "./OrderItemSelectionDemandModel";
import OrderJobModel from "./OrderJobModel";
import VehicleModel from "./Vehicle";
import OrderStatus from "./enums/OrderStatus";

export default class OrderModel {
	constructor(data?: any) {
		if (data) {
			this.id = data.id;

			if (data.date) {
				this.date = new Date(data.date);
			}

			if (data.scheduledStartDate) {
				this.scheduledStartDate = new Date(data.scheduledStartDate);
			}			
			
			this.number = data.number;

			if (data.customer?.id) {
				this.customer = new CounterpartyModel(data.customer);
			}

			if (data.vehicle) {
				this.vehicle = new VehicleModel(data.vehicle);
			}

			if (data.closingDate) {
				this.closingDate = new Date(data.closingDate);
			}

			this.status = data.status;

			if (data.executiveEntityBranch?.id) {
				this.executiveEntityBranch = new LegalEntityBranchModel(data.executiveEntityBranch);
			}

			if (data.creator) {
				this.creator = new EmployeeModel(data.creator);
			}

			if (data.manager) {
				this.manager = new EmployeeModel(data.manager);
			}

			if (data.jobs?.length) {
				this.jobs = data.jobs.map((_: any) => new OrderJobModel(_));
			}

			if (data.items?.length) {
				this.items = data.items.map((_: any) => new OrderItemModel(_));
			}

			if (data.itemSelectionDemands?.length) {
				this.itemSelectionDemands = data.itemSelectionDemands.map((_: any) => new OrderItemSelectionDemandModel(_));
			}

			this.customerNotes = data.customerNotes ?? null;
			this.externalNotes = data.externalNotes ?? null;
			this.internalNotes = data.internalNotes ?? null;

			this.customerJobsTotalCost = data.customerJobsTotalCost ?? 0;
			this.customerItemsTotalCost = data.customerItemsTotalCost ?? 0;
			this.empoloyeeJobsCost = data.empoloyeeJobsCost ?? 0;
		}
	}

	id = 0;
	date = new Date(1970,0,1);
	scheduledStartDate = new Date(1970,0,1);
	number = '';
	customer: CounterpartyModel | null = null;
	vehicle: VehicleModel | null = null;
	closingDate: Date | null = null;
	status: number = OrderStatus.PartsOrdering;

	executiveEntityBranch: LegalEntityBranchModel | null = null;

	creator: EmployeeModel | null = null;
	manager: EmployeeModel | null = null;

	jobs: Array<OrderJobModel> | null = null;
	items: Array<OrderItemModel> | null = null;
	itemSelectionDemands: Array<OrderItemSelectionDemandModel> | null = null;

	customerNotes: string | null = null;
	externalNotes: string | null = null;
	internalNotes: string | null = null;

	customerJobsTotalCost = 0;
	customerItemsTotalCost = 0;
	empoloyeeJobsCost = 0;
}
